import React, { useRef, useEffect } from "react";
import "./About.scss";

const About = () => {
  const divRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
        } else {
          entry.target.classList.remove("in-view");
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (divRef.current) {
      observer.observe(divRef.current);
    }
    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="aboutContent">
      <section className="header">
        <div className="background-image">
          <div className="title">Welcome to tldrBlogs !</div>
          <div className="titleContent">
            <div className="boxContent transition1">
              <div className="description">
                A space for creativity, inspiration & continuous learning !!
              </div>
            </div>
            <div className="boxContent transition2">
              <div className="description">
                Discovering joy in journeys, stories and innovation !!
              </div>
            </div>
            <div className="boxContent transition3">
              <div className="description">
                Sharing our love for exploring places, pages and possibilities.
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mainContent1">
        <div className="whattoexpect" ref={divRef}>
          <div className="details">
            What You Can Expect:
            <ul>
              <li>
                Tech Tips & Tutorials: Step-by-step guides and resources for
                developers and tech enthusiasts.
              </li>
              <li>
                Travel Guides: Stories and tips to inspire your next adventure,
                from hidden gems to popular destinations.
              </li>
              <li>
                Lifestyle & Culture: Articles that explore everyday living,
                personal development, and cultural trends.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
